import {
  CustomSamplingContext,
  Span,
  SpanContext,
  Transaction,
  TransactionContext,
} from '@sentry/types';

export type {
  CustomSamplingContext,
  Span,
  SpanContext,
  Transaction,
  TransactionContext,
};

export type SentryPerformanceTracking = {
  startTransaction(
    context: TransactionContext,
    customSamplingContext?: CustomSamplingContext,
  ): Transaction;
};

export const getSentryDsn = () =>
  'https://ac9dcd12fbaafaa44e2af7925431d599@o43862.ingest.us.sentry.io/4508886103621632';
